import React from 'react'
import './establishment.css'

import Button from '../components/basic/button'
import Header from '../components/shared/header'
import EstablishmentContact from '../components/pages/establishment/establishment-contact'
import EstablishmentServices from '../components/pages/establishment/establishment-card'
import ContactCard from '../components/pages/establishment/contact-card'
import AdditionalInfo from '../components/pages/establishment/additional-info'
import EstablishmentCard from '../components/pages/establishment/establishment-card'

import Image01 from '../assets/img023.png'
import Image02 from '../assets/img002.png'

const screen = () => {
    return (
        
        <div className='screen-main'>

            <Header label="Estabelecimento" rightIcon="bell" />

            <img className='establishment-image' src={Image01} alt='' />

            <EstablishmentCard />

            <h2 className="app-sub-title component-card-title">Contato</h2>
            <div className="component-card-content">
                <ContactCard Icon={'whatsapp'} ContactName='Whatsapp' Description='Fale conosco pelo Whatsapp' Contact='(11) 99999-9999' />
                <ContactCard Icon={'phone'} ContactName='Telefone' Description='Atendimento por ligação' Contact='(11) 3333-3333' />
                <ContactCard Icon={'location'} ContactName='Endereço' Description='Rua das Flores, 123 &nbsp; Centro, São Paulo - SP' Contact='Ver no mapa' />
                <ContactCard Icon={'mail'} ContactName='E-mail' Description='Envie sua mensagem' Contact='contato@salaodoseumanoel.com.br' />
                <AdditionalInfo />
            </div>
        </div>
        
    )
}

export default screen